<template>
  <v-card class="upload-status-card border-radius-standard">
    <v-card-text xs12 v-if="status === 'Inprogress'">
      <v-layout wrap row align-center>
        <v-flex xs1>
          <v-icon size="32" color="primary">description</v-icon>
        </v-flex>
        <v-flex>
          <v-progress-linear :value="messagePercentage" color="primary" />
        </v-flex>
      </v-layout>
      <p style="text-align: right; margin-bottom: 0 !important">
        {{ messageDone }} / {{ messageTotal }} Users
      </p>
      <small class="text--disabled"
        >Be patient it takes few minutes to process all users</small
      >
    </v-card-text>
    <v-card-text xs12 v-if="status === 'Pending'" class="px-0">
      <v-layout wrap row align-center>
        <v-flex xs1>
          <v-icon size="32" color="#ffbf00">error</v-icon>
        </v-flex>
        <v-flex>
          <span class="primary--text"
            ><b>File</b> processing is done, you have <br />
            <b>{{ record }} corrupted rows 😕</b>
          </span>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-text
      xs12
      v-if="status === 'Success' || status === 'Virtual'"
      class="px-0"
    >
      <v-layout wrap row align-center>
        <v-flex xs1>
          <v-icon size="32" color="#3dd598">check_circle</v-icon>
        </v-flex>
        <v-flex>
          <span class="primary--text"
            ><b>Users Data</b> attached successfully 🎉</span
          >
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-text xs12 v-if="status === 'Failed'" class="px-0">
      <v-layout wrap row align-center>
        <v-flex xs1>
          <v-icon size="32" color="#e24b4b">cancel</v-icon>
        </v-flex>
        <v-flex>
          <span class="primary--text"
            ><b>Data rows</b> are not matching Template 😔</span
          >
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions
      xs12
      v-if="status === 'Pending'"
      class="pending-upload-action upload-action border-radius-standard"
    >
      <v-layout wrap row align-center>
        <v-flex>
          <span class="pending-action-text">Status</span>
          Pending
        </v-flex>
        <v-spacer />
        <v-flex>
          <v-btn
            class="action-btn"
            color="#ffbf00"
            dark
            @click="$emit('update-file')"
            >Update User's Data</v-btn
          >
        </v-flex>
      </v-layout>
    </v-card-actions>
    <v-card-actions
      v-if="status === 'Success'"
      class="success-upload-action upload-action border-radius-standard"
    >
      <v-layout wrap row align-center>
        <v-flex>
          <span class="success-action-text">Status</span>
          Successfully Uploaded
        </v-flex>
        <v-spacer />
        <v-flex>
          <v-btn
            class="action-btn"
            color="#3dd598"
            dark
            @click="$emit('update-file')"
            >Update User's Data</v-btn
          >
        </v-flex>
      </v-layout>
    </v-card-actions>
    <v-card-actions
      xs12
      v-if="status === 'Failed'"
      class="failed-upload-action upload-action border-radius-standard"
    >
      <v-layout wrap row align-center>
        <v-flex>
          <span class="failed-action-text">Status</span>
          Failed
        </v-flex>
        <v-spacer />
        <v-flex>
          <v-btn
            class="action-btn"
            color="#e24b4b"
            dark
            @click="$emit('download-file')"
            >Download File Template</v-btn
          >
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "UploadingStatus",
  props: {
    status: {
      type: String,
      required: true,
    },
    record: {
      type: Number,
      default: 0,
    },
    message: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      messageDone: 0,
      messageTotal: 0,
      messagePercentage: 0,
    };
  },
  mounted() {
    this.setMessagePercentage();
  },
  watch: {
    status: {
      immediate: true,
      handler() {
        this.setMessagePercentage();
      },
    },
    message: {
      immediate: true,
      handler() {
        this.setMessagePercentage();
      },
    },
  },
  methods: {
    getMessageTotal() {
      if (this.status !== "Inprogress" || !this.message) return 0;
      return Number(this.message.split(" ")[2]) + 1;
    },
    getMessageDone() {
      if (this.status !== "Inprogress" || !this.message) return 0;
      if (this.messageTotal) {
        return Math.min(Number(this.message.split(" ")[0]), this.messageTotal);
      }
      return Number(this.message.split(" ")[0]);
    },
    setMessagePercentage() {
      if (this.status !== "Inprogress" || !this.message) return 0;
      this.messageTotal = this.getMessageTotal();
      this.messageDone = this.getMessageDone();
      if (!this.messageTotal || !this.messageDone) return 0;
      this.messagePercentage =
        (this.messageDone / Math.max(1, this.messageTotal - 1)) * 100;
      if (this.messagePercentage >= 100) {
        this.$emit("upload-virtual-complete");
      }
    },
  },
};
</script>

<style lang="css" scoped>
.upload-status-card {
  background-color: #f4f5f9;
  box-shadow: none;
}
.upload-action {
  width: 100% !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  font-size: 14px;
  font-weight: bold;
}
.action-btn {
  float: right;
  margin-right: 0;
  height: 27px;
}
.pending-upload-action {
  background-color: rgba(255, 191, 0, 0.2);
}
.pending-action-text {
  color: #ffbf00;
}
.success-upload-action {
  background-color: rgba(61, 213, 152, 0.2);
}
.success-action-text {
  color: #3dd598;
}
.failed-upload-action {
  background-color: rgba(226, 75, 75, 0.2);
}
.failed-action-text {
  color: #e24c4b;
}
</style>
